// day_of_week: 0=Pazar ... 6=Cumartesi (043 ISO şeması).
const DAY_NAMES = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
const DEFAULT_START = '09:00';
const DEFAULT_END = '18:00';

/** "HH:MM:SS" veya "HH:MM" → "HH:MM" (native time input formatı). */
function toInputTime(value) {
  if (!value) return '';
  return String(value).slice(0, 5);
}

/**
 * Tek gün editör satırı — controlled, presentational.
 * State + kaydetme parent'tadır (WorkingHoursPage). API çağrısı YOK.
 *
 * @param {object}   day       { day_of_week, is_working_day, start_time, end_time, id, ... }
 * @param {Function} onChange  güncellenmiş tam gün objesini parent'a döner
 * @param {boolean}  disabled  rol (supervisor read-only)
 */
export function WorkingHoursDayRow({ day, onChange, disabled = false }) {
  const isWorking = day.is_working_day;
  const start = toInputTime(day.start_time);
  const end = toInputTime(day.end_time);
  const invalid = isWorking && start && end && start >= end;

  const handleWorkingToggle = (e) => {
    if (e.target.checked) {
      // false→true: start/end boşsa makul default (boş zorunlu input yerine).
      onChange({
        ...day,
        is_working_day: true,
        start_time: day.start_time || DEFAULT_START,
        end_time: day.end_time || DEFAULT_END,
      });
    } else {
      // true→false: time NULL olmalı (043 CHECK working_hours_time_consistency).
      onChange({ ...day, is_working_day: false, start_time: null, end_time: null });
    }
  };

  // grace_minutes dahil day'in diğer tüm alanları ...day ile korunur — Row dokunmaz.
  const handleTimeChange = (field) => (e) => {
    onChange({ ...day, [field]: e.target.value });
  };

  return (
    <div className="flex items-center gap-4 py-3 border-b border-slate-100 last:border-0">
      <span className="w-24 text-sm font-medium text-slate-700">
        {DAY_NAMES[day.day_of_week]}
      </span>

      <label className="flex items-center gap-2 text-sm text-slate-600 cursor-pointer select-none">
        <input
          type="checkbox"
          checked={isWorking}
          onChange={handleWorkingToggle}
          disabled={disabled}
          className="w-4 h-4 rounded border-slate-300 text-blue-600"
        />
        Çalışma günü
      </label>

      {isWorking ? (
        <div className="flex items-center gap-2">
          <input
            type="time"
            value={start}
            onChange={handleTimeChange('start_time')}
            disabled={disabled}
            className="border border-slate-300 rounded-lg px-2 py-1.5 text-sm disabled:bg-slate-50 disabled:text-slate-400"
          />
          <span className="text-slate-400">–</span>
          <input
            type="time"
            value={end}
            onChange={handleTimeChange('end_time')}
            disabled={disabled}
            className="border border-slate-300 rounded-lg px-2 py-1.5 text-sm disabled:bg-slate-50 disabled:text-slate-400"
          />
          {invalid && (
            <span className="text-xs text-red-500">Başlangıç saati bitişten önce olmalıdır</span>
          )}
        </div>
      ) : (
        <span className="text-sm text-slate-400">(Kapalı)</span>
      )}
    </div>
  );
}
